module.exports = __webpack_public_path__ + "img/hover-wx.621c5a08.png";